<template>
    <button :class="[
        'px-4 py-2 rounded transition-colors duration-200 flex items-center justify-between',
        `bg-${bgColor} text-${textColor} hover:bg-${hoverBgColor}`,
    ]" @click="copyToClipboard">

        <svg v-if="!copied" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="size-4 text-green-500">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75" />
        </svg>


        <span class="ml-2">{{ buttonText }}</span>
    </button>
</template>

<script>
export default {
    name: "CopyButton",
    data() {
        return {
            copied: false,
        };
    },
    props: {
        bgColor: {
            type: String,
            default: "gray-900", // Color de fondo predeterminado
        },
        textColor: {
            type: String,
            default: "white", // Color del texto predeterminado
        },
        hoverBgColor: {
            type: String,
            default: "blue-600", // Color de fondo al pasar el mouse
        },
        buttonText: {
            type: String,
            default: "Copiar", // Texto del botón
        },
        textToCopy: {
            type: String,
            required: true, // Texto que se copiará al portapapeles
        },
    },
    methods: {
        copyToClipboard() {
            navigator.clipboard.writeText(this.textToCopy).then(
                () => {
                    this.copied = true;
                    setTimeout(() => {
                        this.copied = false;
                    }, 2000);
                    console.log("Texto copiado al portapapeles: ", this.textToCopy);
                },
                (err) => {
                    console.error("Error al copiar el texto: ", err);
                }
            );
        },
    },
};
</script>

<style scoped>
/* Estilo opcional */
</style>
